module.exports = __webpack_public_path__ + "static/img/hom_jgzx.ccfb950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hom_jgzx.jpg
// module id = 12BQ
// module chunks = 169